export const locale = {
    lang: 'en',
    data: {
        OMNI_SEARCH: {
            TITLES: {
                CANCEL: 'Cancel',
                PLACEHOLDER: 'Address, Neighborhood, or Building Name',
            }
        }
    }
};